import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import countrys from '../js/country';
import api from '../js/api';
import util from '@utils/util';
export default {
  name: 'select-code',
  props: {
    mb: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      countrysHtml: '',
      countryCode: '',
      code: 1,
      ctFlag: '//esx.esxscloud.com/live/search3/AS.png'
    };
  },
  components: {},
  methods: {
    changeCode: function changeCode(e) {
      var options = e.target.options;
      var ele = options[options.selectedIndex];
      var country = ele.getAttribute('data-country');
      this.ctFlag = "//esx.esxscloud.com/live/search3/".concat(country, ".png");
      this.code = ele.value;
      this.$emit('selectCode', this.code, ele.dataset.country);
    },
    setSelected: function setSelected() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var regStr, regexp, countrysMap;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return util.getCountryCodeByIp();
            case 2:
              _this.countryCode = _context.sent;
              regStr = "data-country=\"".concat(_this.countryCode, "\"");
              regexp = new RegExp(regStr);
              countrysMap = countrys.map(function (item) {
                item = item || '';
                if (regexp.test(item)) {
                  _this.ctFlag = "//esx.esxscloud.com/live/search3/".concat(_this.countryCode, ".png");
                  var _item$match = item.match(/\d+/g);
                  var _item$match2 = _slicedToArray(_item$match, 1);
                  _this.code = _item$match2[0];
                  _this.$emit('selectCode', _this.code);
                  item = item.replace(regexp, "".concat(regStr, " selected=\"selected\""));
                  return item;
                } else {
                  return item;
                }
              });
              _this.countrysHtml = countrysMap.join('');
              // });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  beforeMount: function beforeMount() {
    this.setSelected();
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};